import { forwardRef } from 'react';
import styled from 'styled-components';
import { color, space, typography } from 'styled-system';
import { HTMLKaajaProps } from '../../types';

type Option = { label: string; value: string | number | undefined };

type SelectProps = HTMLKaajaProps<'select'> & { options: Option[] };

const Wrapper = styled('div')({
  display: 'grid',
  gridTemplateAreas: "'select'",
  alignItems: 'center',
  width: '100%',

  '&::after': {
    content: "''",
    width: '0.8em',
    height: '0.5em',
    backgroundColor: 'black',
    clipPath: 'polygon(100% 0%, 0 0%, 50% 100%)',
    gridArea: 'select',
    justifySelf: 'end',
    marginRight: '12px',
  },
});

const Styled = styled('select')<HTMLKaajaProps<'select'>>(
  (props) => ({
    width: '100%',
    padding: '14px 12px',
    fontSize: props.theme.fontSizes[1],
    color: props.theme.colors.neutral900,
    borderRadius: props.theme.radii.base,
    backgroundColor: props.theme.colors.white,
    border: `1px solid ${props.theme.colors.neutral300}`,
    appearance: 'none',
    gridArea: 'select',
    outline: 'none',

    '&:focus': {
      outlineColor: props.theme.colors.blueDark900,
      outlineStyle: 'solid',
      outlineWidth: '1px',
    },
  }),
  space,
  color,
  typography
);

const Select = forwardRef<HTMLSelectElement, SelectProps>((props, ref) => {
  const { options, ...rest } = props;

  return (
    <Wrapper>
      <Styled ref={ref} {...rest}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Styled>
    </Wrapper>
  );
});

export { Select };
